module.exports = __webpack_public_path__ + "static/media/bg-2.82b4804f.jpg";